module.exports = __webpack_public_path__ + "static/media/black_number_of_sessions.644e3f08.svg";